import React from "react";

function PieChart01({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill={fill ?? ""}
      {...restProps}
    >
      <path
        d="M10.117 1.547c-.485.12-.825.487-.918.99-.022.123-.031 1.501-.025 4.067l.009 3.879.074.18c.106.26.232.426.433.57.35.25.115.238 4.56.227 3.922-.01 3.968-.011 4.127-.079.335-.143.606-.437.705-.764.093-.307.057-.918-.101-1.721-.554-2.809-2.349-5.173-4.881-6.426-1.001-.495-1.927-.771-3.082-.919-.467-.06-.673-.061-.901-.004m-3.626.655c-.07.017-.31.12-.534.229A9.134 9.134 0 0 0 1.237 8a9.082 9.082 0 0 0-.392 2.9 9.17 9.17 0 0 0 4.097 7.379c2.691 1.797 6.209 2.016 9.123.568a8.294 8.294 0 0 0 1.453-.896 9.204 9.204 0 0 0 2.82-3.518c.128-.279.145-.344.144-.55-.001-.259-.072-.434-.237-.588-.318-.294-.828-.297-1.128-.006-.076.075-.196.271-.318.524-.398.826-.806 1.419-1.399 2.033a7.183 7.183 0 0 1-2.117 1.538 7.306 7.306 0 0 1-3.731.746 7.41 7.41 0 0 1-4.969-2.3c-1.053-1.096-1.712-2.404-1.987-3.947-.067-.373-.078-.543-.078-1.233 0-.683.011-.861.075-1.219.289-1.614.975-2.949 2.101-4.087.584-.589 1.19-1.022 2.018-1.441.439-.222.514-.272.612-.409.064-.088.128-.232.149-.333.116-.558-.43-1.092-.982-.959m4.83 1.066c2.792.483 5.111 2.578 5.89 5.323.109.383.222.952.222 1.114v.128h-6.6V6.517c0-2.787.008-3.317.046-3.317.025 0 .224.031.442.068"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default PieChart01;
